import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import PredictionPanel from './components/PredictionPanel';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import { getServiceInfo, ServiceInfo } from './services/api';

function App() {
  const [serviceInfo, setServiceInfo] = useState<ServiceInfo | null>(null);
  const [showPrediction, setShowPrediction] = useState(false);

  useEffect(() => {
    getServiceInfo()
      .then(setServiceInfo)
      .catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-cyber-darker relative overflow-hidden">
      {/* 背景效果 */}
      <div className="fixed inset-0 bg-grid-pattern bg-grid opacity-30 pointer-events-none" />
      <div className="fixed inset-0 bg-radial-glow pointer-events-none" />
      
      {/* 扫描线效果 */}
      <div className="scan-lines opacity-30" />
      
      {/* 浮动光点 */}
      <motion.div
        className="fixed w-96 h-96 rounded-full bg-cyber-purple/10 blur-3xl"
        animate={{
          x: [0, 100, 0],
          y: [0, 50, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{ top: '10%', left: '10%' }}
      />
      <motion.div
        className="fixed w-80 h-80 rounded-full bg-cyber-blue/10 blur-3xl"
        animate={{
          x: [0, -80, 0],
          y: [0, 80, 0],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{ bottom: '20%', right: '15%' }}
      />

      {/* 主内容 */}
      <div className="relative z-10">
        <Header />
        
        <main>
          <AnimatePresence mode="wait">
            {!showPrediction ? (
              <motion.div
                key="landing"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Hero onStartPredict={() => setShowPrediction(true)} />
                <Features />
                <HowItWorks />
              </motion.div>
            ) : (
              <motion.div
                key="prediction"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
              >
                <PredictionPanel 
                  serviceInfo={serviceInfo}
                  onBack={() => setShowPrediction(false)}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default App;

